import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Updated ToastContainerConfig to enforce consistent styles without altering background color
export function ToastContainerConfig(): any {
  return (
    <ToastContainer
      autoClose={3000}
      hideProgressBar
      closeButton={false}
      position="top-right"
      toastStyle={{
        fontSize: '15px',
        fontWeight: '500',
        borderRadius: '10px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      }}
    />
  );
}

// Toast types
export const showSuccessToast = (message: any, position: any = 'top-center') => {
  const isWelcomeToast = message.includes('Welcome back, Monica');
  const isLogoutToast = message.toLowerCase().includes('logged out successfully');
  toast.success(message, {
    position: isLogoutToast ? 'top-center' : position,
    icon: isWelcomeToast ? false : (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M16.6654 5L7.4987 14.1667L3.33203 10" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    style: isWelcomeToast
      ? {
        background: '#4a4848',
        color: '#ffffff',
        padding: '16px 16px 16px 20px', // 👈 extra left padding
        borderRadius: '10px',
        fontSize: '15px',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      }
      : {
        padding: '16px',
        borderRadius: '10px',
        border: '2px solid var(--tailwind-colors-emerald-500, #10B981)',
        background: 'var(--tailwind-colors-emerald-50, #ECFDF5)',
        boxShadow: '0 4px var(--blur-blur-md, 12px) 0 rgba(0, 0, 0, 0.25)',
        color: '#0b0000ff',
        fontSize: '15px',
        fontWeight: '500',
      },
  });
};

export const showErrorToast = (message: any, position: any = 'top-right') => {
  toast.error(message, {
    position,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M16.6654 5L7.4987 14.1667L3.33203 10" stroke="#ff4d4f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    style: {
      borderRadius: '10px',
      fontSize: '15px',
      fontWeight: '500',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      padding: '16px',
    },
  });
};

export const showWarningToast = (message: any, position: any = 'top-right') => {
  toast.warn(message, {
    position,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M16.6654 5L7.4987 14.1667L3.33203 10" stroke="#faad14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    style: {
      borderRadius: 'var(--border-radius-default, 6px)',
      border: '2px solid var(--tailwind-colors-emerald-500, #10B981)',
      background: 'var(--tailwind-colors-emerald-50, #ECFDF5)',
      boxShadow: '0 4px var(--blur-blur-md, 12px) 0 rgba(0, 0, 0, 0.25)',
      color: '#080808ff',
      padding: '16px',
    },
  });
};
